import React from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie, Check, X } from "lucide-react";
import { useConsent } from "@/context/ConsentContext";

export default function CookieBanner() {
  const { consent, accept, reject } = useConsent();
  if (consent !== null) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
        data-testid="cookie-banner"
        className="fixed bottom-4 left-4 right-4 md:left-6 md:right-6 z-[60] max-w-4xl md:mx-auto"
      >
        <div className="bg-[#faf7f2] border border-[#b08d57]/40 shadow-2xl backdrop-blur-xl p-5 md:p-6 flex flex-col md:flex-row gap-5 md:gap-8 items-start md:items-center">
          <div className="flex items-start gap-3 flex-1">
            <div className="w-10 h-10 border border-[#b08d57]/40 flex items-center justify-center text-[#b08d57] flex-shrink-0">
              <Cookie className="w-5 h-5" />
            </div>
            <div>
              <div className="font-display font-bold text-[#1a1a1a] text-sm mb-1">
                We use cookies to improve your experience
              </div>
              <p className="text-[#6b6b6b] text-xs leading-relaxed">
                We use essential cookies to run the site and analytics/marketing cookies (Meta, Google, LinkedIn) to improve our services and remarketing. Read our{" "}
                <Link to="/privacy-policy" className="text-[#b08d57] hover:underline">Privacy Policy</Link>.
              </p>
            </div>
          </div>
          <div className="flex gap-3 w-full md:w-auto">
            <button
              type="button"
              onClick={reject}
              data-testid="cookie-reject"
              className="flex-1 md:flex-initial border border-[#e5ddd0] hover:border-[#e5ddd0] text-[#4a4a4a] hover:text-[#1a1a1a] px-5 py-3 text-xs font-semibold uppercase tracking-wider transition-colors inline-flex items-center justify-center gap-2"
            >
              <X className="w-3 h-3" /> Reject
            </button>
            <button
              type="button"
              onClick={accept}
              data-testid="cookie-accept"
              className="flex-1 md:flex-initial bg-[#b08d57] hover:bg-[#8a6a3d] text-white px-5 py-3 text-xs font-semibold uppercase tracking-wider transition-colors inline-flex items-center justify-center gap-2"
            >
              <Check className="w-3 h-3" /> Accept All
            </button>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
